import { common_axios } from "../App";
import { setLoader } from "../redux/features/authSliceandSidebar";

export const getVehicles = async (payload) => {
  try {
    await common_axios.post(``);
  } catch (e) {}
};

export const getSiteDetails = async (payload) => {
  try {
    const res = await common_axios.get(`/site/v1/get/detail`);
    return res;
  } catch (e) {}
};

export const getVendorDetails = async (payload) => {
  try {
    const res = await common_axios.get(`/vendor/v1/get/detail`);
    return res;
  } catch (e) {}
};

export const getShiftDetails1 = async (payload) => {
  try {
    const res = await common_axios.get(`/shift/v1/get/detail`);
    return res;
  } catch (e) {}
};

export const vehicleTypes = async () => {
  try {
    const res = await common_axios.get("/vehicle/v1/get/vehicle/type");
    return res;
  } catch (e) {}
};

export const vehicleListVendors = async (payload) => {
  try {
    const res = await common_axios.post(
      "/trip/v1/get/vehicle-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const getOpenTrips = async (payload) => {
  try {
    const res = await common_axios.post("/trip/v1/open-trip-list", payload);
    return res;
  } catch (e) {}
};

//Loading...
export const saveDetailsTrips = async (payload) => {
  try {
    const res = await common_axios.post("/trip/v1/save-detail", payload);
    return res;
  } catch (e) {}
};

export const uploadfilesgeneric = async (payload, url) => {
  try {
    const res = await common_axios.post(url, payload);
    return res;
  } catch (e) {}
};

export const getFuelDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/fuel/v1/get/vehicle-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const validDateDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/trip/v1/validate-trip-readings",
      payload
    );
    return res;
  } catch (e) {}
};

export const updateTripDetailsCount = async (payload) => {
  try {
    const res = await common_axios.post("/trip/v1/update-trip-count", payload);
    return res;
  } catch (e) {}
};

export const viewTripDetails = async (payload) => {
  try {
    const res = await common_axios.post("/trip/v1/get-trip-details", payload);
    return res;
  } catch (e) {}
};

//Loading...
export const getAllTripDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/trip/v1/get/all-trip-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const getAllFuelDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/trip/v1/get/all-fuel-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const updateTripDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/trip/v1/update-trip-with-attachments",
      payload
    );
    return res;
  } catch (e) {}
};

export const viewFuelDetails = async (payload) => {
  try {
    const res = await common_axios.post("/fuel/v1/get-fuel-details", payload);
    return res;
  } catch (e) {}
};

export const getPortalFields1 = async (payload) => {
  try {
    const res = await common_axios.post("/trip/v1/get-portal-fields", payload);
    return res;
  } catch (e) {}
};

export const getdriversList = async (id) => {
  try {
    const res = await common_axios.get("/driver/list?vehicleTypeId=" + id);
    return res;
  } catch (e) {}
};

export const saveVehicleDetails = async (payload) => {
  try {
    const res = await common_axios.post("/vehicle/v1/saveOrUpdate", payload);
    return res;
  } catch (e) {}
};

export const getVehicleDetails = async (payload) => {
  try {
    const res = await common_axios.post(
      "/vehicle/v1/get/vehicle/details",
      payload
    );
    return res;
  } catch (e) {}
};

//Loading.
export const saveVendorDetails = async (payload) => {
  try {
    const res = await common_axios.post("/vendor/v1/save-or-update", payload);
    return res;
  } catch (e) {}
};

export const saveDriverDetails = async (payload) => {
  try {
    const res = await common_axios.post("/driver/save-or-update", payload);
    return res;
  } catch (e) {}
};
